import {
  Checkbox,
  ListItemText,
  MenuItem,
  Select,
  SelectProps,
} from "@mui/material";
import Help from "../Help";

type Props = {
  value: number[],
  onChange: (newValue: number[]) => void,
  options: {key: number, label: string, disabled?: boolean, help?: string}[],
  required?: boolean,
  id?: string,
  sx?: SelectProps["sx"],
  label?: SelectProps["label"],
  fullWidth?: SelectProps["fullWidth"],
  size?: SelectProps["size"],
};

const CheckboxSelect = ({ options, required, onChange, value, ...props }: Props) => {
  return <Select
    multiple
    value={value}
    renderValue={(selected) => options.filter(o => selected.includes(o.key)).map(o => o.label).join(', ')}
    onChange={e => {
      let { value } = e.target;
      value = (typeof value === 'string') ? value.split(',').map(v => parseInt(v)) : value;
      onChange(value);
    }}
    error={required && value.length === 0}
    {...props}
  >
    {options.map(({ key, label, disabled, help }) => <MenuItem key={key} value={key} disabled={disabled}>
      <Checkbox checked={value.includes(Number(key))} />
      <ListItemText primary={label} />
      {help ? <Help text={help} /> : null}
    </MenuItem>)}
  </Select>
}

export default CheckboxSelect;
